import { DataService } from "./dataService";

export const TntConsolService = {
  get_tnt_land_cons_freight: async (data) => {
    return DataService.get("/admin/get_tnt_land_cons_freight", data);
  },
  import_tnt_land_cons_freight: async (data) => {
    return DataService.post("/admin/import_tnt_land_cons_freight", data);
  },
  export_tnt_land_cons_freight: async (data) => {
    return DataService.get("/admin/export_tnt_land_cons_freight", data);
  },
};

export default TntConsolService;
